module.exports = __webpack_public_path__ + "static/media/symbol.379fe0eb.png";